


'use strict';


document.addEventListener('DOMContentLoaded', function () {


    // ---------- Init
    var modal		= document.querySelector('#modal--avertissement');
    var btn			= document.querySelector('#modal--avertissement-close');
    var dejaVu	= sessionStorage.getItem('avertissement');

    // ---------- Traitement
    if (modal) {

      if (dejaVu !== 'dejavu') {
        
        modal.showModal();
        
        btn.addEventListener('click', function() {
          modal.close();
          modal.classList.add('hidden');
        });

        // ---------- End
        sessionStorage.setItem('avertissement', 'dejavu');

      } else {
          modal.classList.add('hidden');
      };//  if (dejaVu !== 'dejavu') {
      
    };// if (modal) {
      
}); // document.addEventListener('DOMContentLoaded', function() {
